import { useTranslation } from 'react-i18next'
import { PortfolioIcon } from '@/components/ui/PortfolioIcon'

export function Experience() {
  const { t } = useTranslation()
  const skills = t('portfolio.experience.skills', {
    returnObjects: true,
  }) as string[]
  const icons = ['chip', 'code', 'network', 'cube', 'factory'] as const
  return (
    <section className="experience-section">
      <div className="experience-image">
        <img
          src="/images/portfolio/transistor-to-cloud.webp"
          alt={t('portfolio.experience.image')}
          width="1536"
          height="1024"
          loading="lazy"
        />
      </div>
      <div className="shell experience-inner">
        <div className="experience-copy">
          <p className="eyebrow">{t('portfolio.experience.eyebrow')}</p>
          <h2>
            {t('portfolio.experience.title')}
            <span>{t('portfolio.experience.accent')}</span>
          </h2>
          <p>{t('portfolio.experience.description')}</p>
          <ul className="skill-list">
            {skills.map((skill, i) => (
              <li key={skill}>
                <PortfolioIcon name={icons[i] ?? 'chip'} />
                <span>{skill}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  )
}
